// Lib
import React from 'react';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { MouseTransition, MultiBackend, MultiBackendOptions, TouchTransition } from 'react-dnd-multi-backend';
import { DndProvider } from 'react-dnd';

// Device
import platformSingleton from '../../platform/platformSingleton';

// Customised touch backend
import TouchBackend from '../../../node_module_clones/touch-backend/src';

// Types
import { MilanoteApplicationMode, PlatformType } from '../../../common/platform/platformTypes';

const TOUCH_BACKEND_DEFINITION = {
    id: 'touch',
    backend: TouchBackend,
    options: {
        enableMouseEvents: true,
        ignoreContextMenu: platformSingleton.appMode !== MilanoteApplicationMode.desktop,
    },
    preview: true,
};

const TouchOnly: MultiBackendOptions = {
    backends: [TOUCH_BACKEND_DEFINITION],
};

const Html5toTouch: MultiBackendOptions = {
    backends: [
        {
            id: 'html5',
            backend: HTML5Backend,
            transition: MouseTransition,
        },
        {
            ...TOUCH_BACKEND_DEFINITION,
            transition: TouchTransition,
        },
    ],
};

const DndBackendOptions =
    platformSingleton.type === PlatformType.ipad
        ? // iPad uses the touch backend only as the trackpad will respond to drags instantly,
          // otherwise, it will have a drag delay
          TouchOnly
        : // All other platforms use html5 + touch
          Html5toTouch;

const WorkspaceDndProvider = (props: { children: React.ReactNode }) => (
    <DndProvider backend={MultiBackend} options={DndBackendOptions}>
        {props.children}
    </DndProvider>
);

export default WorkspaceDndProvider;
